'use client';
import React, { useState } from 'react';
import Button from '../../../button';
import { Menu, MenuItem, Typography } from '@mui/material';
import { HiOutlineChevronUp } from '@react-icons/all-files/hi/HiOutlineChevronUp';
import { HiOutlineChevronDown } from '@react-icons/all-files/hi/HiOutlineChevronDown';

export const GroupChartBy = () => {
  const options = ['Ativo', 'Classe'];
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    setSelectedIndex(index);
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        sx={{
          minWidth: 140,
          fontWeight: 500,
          borderColor: '#E3E3E3',
          height: 32,
        }}
        onClick={handleClick}
        endIcon={open ? <HiOutlineChevronUp /> : <HiOutlineChevronDown />}
      >
        <Typography
          component="span"
          variant="body2"
          fontWeight={500}
          color="helperText.disabled"
        >
          Agrupar por:{' '}
          <Typography
            component="span"
            variant="body2"
            fontWeight={500}
            color="secondary"
          >
            {options[selectedIndex]}
          </Typography>
        </Typography>
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        {options.map((option, index) => (
          <MenuItem
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
